import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const Badge = styled.div<IWithSize & { active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
    width: 26px;
    height: 20px;
    border-radius: 4px;
  background-color: ${props =>
    props.active
      ? props.theme.colors.palette.emerald
      : '#C2C2C2'};
    font-family: Montserrat, sans-serif;
  font-size: 14px;
    font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: center;
  color: #fff;
`

export default Badge
